import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { I18nResources, useI18n } from '@app-velocity/i18n';
import { Tooltip } from '@app-velocity/ui';
import { InfoOutlineIcon } from '@app-velocity/icons';

import { Title } from './components/Title';

const StyledSection = styled('section')<{ compact: boolean }>(
  ({ theme, compact }) => ({
    background: 'var(--background-background-color)',
    border: '1px solid var(--stroke-stroke-primary-color)',
    borderRadius: theme.spacing(2),
    padding: compact
      ? `${theme.spacing(6)} ${theme.spacing(4)}`
      : `${theme.spacing(6)} ${theme.spacing(6)}`,
    flex: 1,
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  })
);

const StyledHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '100%',
  svg: {
    fill: 'var(--text-text-color-primary)',
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}));

export type SectionProps = {
  children: ReactNode;
  tooltip: I18nResources;
  compact?: boolean;
  className?: string;
};

export const InfoSection = ({
  children,
  tooltip,
  compact,
  className,
}: SectionProps) => {
  const { t } = useI18n();

  return (
    <StyledSection compact={compact || false} className={className}>
      <StyledHeader>
        <Tooltip title={t(tooltip)}>
          <InfoOutlineIcon />
        </Tooltip>
      </StyledHeader>
      {children}
    </StyledSection>
  );
};

InfoSection.Title = Title;
